// src/pages/ClientData/components/ClientMatchesDialog.js
import React from 'react';

// Diálogo de escolha quando a pesquisa por nome devolve mais do que um cliente.
// Ao seleccionar uma linha, o código é preenchido e a consulta completa arranca.
const ClientMatchesDialog = ({ matches, onSelect, onClose }) => {
  if (!matches || matches.length === 0) return null;

  return (
    <div className="cd-bulk-overlay">
      <div className="cd-bulk-dialog cd-matches-dialog" role="dialog" aria-modal="true">
        <div className="cd-bulk-header">
          <h3>👥 {matches.length} clientes encontrados</h3>
        </div>

        <p className="cd-bulk-current">Seleccione o cliente pretendido:</p>

        <ul className="cd-matches-list">
          {matches.map((cliente) => (
            <li key={cliente['Cod. Cliente']}>
              <button
                type="button"
                className="cd-match-item"
                onClick={() => onSelect(cliente)}
              >
                <span className="cd-match-code">{cliente['Cod. Cliente']}</span>
                <span className="cd-match-info">
                  <strong>{cliente['Nome']}</strong>
                  {cliente['Email'] && <span className="cd-match-meta">✉️ {cliente['Email']}</span>}
                  {cliente['Gestor'] && <span className="cd-match-meta">👤 {cliente['Gestor']}</span>}
                </span>
              </button>
            </li>
          ))}
        </ul>

        <div className="cd-bulk-actions">
          <button type="button" className="action-btn chat-btn" onClick={onClose}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientMatchesDialog;
